import { createTheme } from "@mui/material";
import { green, purple } from "@mui/material/colors";

export const theme_three = createTheme({
    palette: {
        info: {
            main: '#2654A2',
        },
        background: {
            default: '#fafafa'
        },
        primary: {
            main: '#2f3eea'
        }
    },
    typography: {
        h2: {
            fontFamily: 'NeoSansProBold'
        },
        body2: {
            fontFamily: 'NeoSansProRegular'
        },
        body1: {
            fontFamily: 'NeoSansProMedium'
        },
    },
})